// Lib
import React from 'react';

// Components
import ArrowTool from './ArrowTool';

const StartArrowTool = (props) => <ArrowTool {...props} styleProp="startStyle" iconDirection="left" />;

export default StartArrowTool;
